import { put, takeEvery, delay } from "redux-saga/effects";
import * as AuthService from "../../secure/services/authService";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/authActions";

export function* fetchRoleListViewSaga() {
  try {
    const response = yield AuthService.doFetchRoleListView();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.fetchRoleListViewSuccess(result));
    } else yield put(actions.fetchRoleListViewFailed());
  } catch (error) {
    yield put(actions.fetchRoleListViewFailed());
  }
}

export function* fetchDBCheckSaga(action) {
  try {
    const response = yield AuthService.doFetchDBCheck();
    const { isError, result } = response.data;
    if (!isError) {
      yield put(actions.fetchDBCheckSuccess(result.status));
      if (!result.status) {
        yield delay(10000);
        yield put(actions.fetchDBCheck());
        action.payload("/status");
      } else {
        yield put(actions.fetchRoleListView());
      }
    } else yield put(actions.fetchDBCheckFailed());
  } catch (error) {
    yield put(actions.fetchDBCheckFailed());
  }
}

export function* watchTokenAsync() {
  yield takeEvery(actionTypes.FETCH_ROLE_LIST_VIEW, fetchRoleListViewSaga);
  yield takeEvery(actionTypes.STUDY_INFO_DB_CHECK, fetchDBCheckSaga);
}
